module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-one.a4732a5c.png";